export const module = {
  info: {
    name: 'voip-rate-division-sms',
    caption: 'voip SMS rate division'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
